import { Card, Col, Row, Space, Typography } from 'antd'
import { CloseCircleOutlined } from '@ant-design/icons'
import React from 'react'
import { SegmentType } from '.'
const { Title } = Typography

const LongTermCareCard = ({
    position,
    initValues,
    handleSetLongTermCares,
    handleRemove,
}) => {
    let values = { ...initValues }
    delete values.type
    return (
        <>
            <Col span={1}></Col>
            <Col span={10}>
                <Card
                    style={{
                        width: '100%',
                    }}
                >
                    <Space
                        direction="vertical"
                        size="middle"
                        style={{ display: 'flex' }}
                    >
                        <Row>
                            <Col span={20}>
                                <Title level={5}>Long term care</Title>
                            </Col>
                            <Col span={4}>
                                <CloseCircleOutlined
                                    style={{ fontSize: '18px', color: 'red' }}
                                    onClick={() =>
                                        handleRemove(
                                            SegmentType.longTermCare,
                                            position
                                        )
                                    }
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <div className="material-textfield">
                                    <input
                                        placeholder=""
                                        type="text"
                                        name="totalPremium"
                                        onChange={(e) => {
                                            handleSetLongTermCares(
                                                position,
                                                'totalPremium',
                                                e.target.value
                                            )
                                        }}
                                        value={values.totalPremium}
                                        className="material-textfield-input"
                                    />
                                    <label
                                        style={{
                                            fontWeight: 'normal',
                                        }}
                                    >
                                        Total premium
                                    </label>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <div className="material-textfield">
                                    <input
                                        placeholder=""
                                        type="text"
                                        name="annualBenefit"
                                        onChange={(e) => {
                                            handleSetLongTermCares(
                                                position,
                                                'annualBenefit',
                                                e.target.value
                                            )
                                        }}
                                        value={values.annualBenefit}
                                        className="material-textfield-input"
                                    />
                                    <label
                                        style={{
                                            fontWeight: 'normal',
                                        }}
                                    >
                                        Annual benefit
                                    </label>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <div className="material-textfield">
                                    <input
                                        placeholder=""
                                        type="text"
                                        name="deathBenefit"
                                        onChange={(e) => {
                                            handleSetLongTermCares(
                                                position,
                                                'deathBenefit',
                                                e.target.value
                                            )
                                        }}
                                        value={values.deathBenefit}
                                        className="material-textfield-input"
                                    />
                                    <label
                                        style={{
                                            fontWeight: 'normal',
                                        }}
                                    >
                                        Death benefit
                                    </label>
                                </div>
                            </Col>
                        </Row>
                    </Space>
                </Card>
            </Col>
        </>
    )
}

export default LongTermCareCard
